
export default {

    guardNavigation(adm_permissoes, permissao){
        return Number(adm_permissoes) >= Number(permissao)
    }

}
